import useYesObject from 'modules/shared/hooks/useYesObject'
import { Interaction } from 'types/shared'

type UseInteractionModelParams = {
  interactionUuid?: string
}

const useInteraction = ({ interactionUuid }: UseInteractionModelParams) => {
  return useYesObject<Interaction>({
    objectUUID: interactionUuid,
    objectclassUUID: window.interactionObjectclassUuid,
    objectSituation: [window.draftSituationCode, window.activeSituationCode],
    displayMessageOnNoItemsFound: false
  })
}

export default useInteraction
